import { useTranslation } from "react-i18next";
import { useGetAllPersonsQuery } from "@/services/api";
import { FormButtonSelect } from "@/shared/Components/Form/FormButtonSelect";
import type { Dispatch, SetStateAction } from "react";
import { Option } from "./Option";
import styles from "./styles.module.scss";

export const PersonSelect = ({ setPerson }: { setPerson?: Dispatch<SetStateAction<boolean>> }) => {
  const { t } = useTranslation();

  const { data: persons, isLoading } = useGetAllPersonsQuery();
  return (
    <div className={styles.wrapper} onClick={() => setPerson && setPerson(true)}>
      <FormButtonSelect
        loading={isLoading}
        name={"currentNote.personId"}
        placeholder={t("notesPage.selectPerson")}
        showSearch
        filterOption={(input, option) =>
          ((option?.label as string) ?? "")
            .toLowerCase()
            .split(" ")
            .join("")
            .includes(input.toLowerCase().split(" ").join(""))
        }
        optionRender={(item) => {
          return <Option person={item.data.person} />;
        }}
        options={persons?.persons.map((item) => ({
          person: item,
          value: item.id,
          label: `${item?.firstName ?? ""} ${item?.middleName ?? ""} ${item?.lastName ?? ""}`,
        }))}
      />
    </div>
  );
};
